export default __webpack_public_path__ + "static/media/Acolyte's Girdle of the Earthen Prison.b477111c.jpg";